import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApiUrlResolver } from '@core/api/api-url.resolver';

export const apiHostInterceptor: HttpInterceptorFn = (request, next) => {
  const replaceApiHost = (request: HttpRequest<any>): HttpRequest<any> => {
    const apiConfigResolver = inject(ApiUrlResolver);
    if (request.url.includes('@api')) {
      const url = request.url.replace('@api', apiConfigResolver.getConfig().apiHost);
      request = request.clone({
        url,
      });
    }

    return request;
  };

  return next(replaceApiHost(request));
};
